(function () {
  var API_HOST = "https://api.judge.me/api/v1/";
  var DOM_TIMEOUT_MS = 14000;
  var DOM_POLL_MS = 400;
  var TOKEN_WAIT_MS = 4000;

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function stripHtml(str) {
    var el = document.createElement("div");
    el.innerHTML = str;
    return (el.textContent || "").trim();
  }

  function truncateText(text, max) {
    if (!text || text.length <= max) return text;
    return text.substring(0, max - 3) + "...";
  }

  function discoverJudgeMeToken() {
    if (window.jdgmSettings && window.jdgmSettings.api_token) {
      return String(window.jdgmSettings.api_token).trim();
    }
    if (window.jdgm && window.jdgm.api_token) {
      return String(window.jdgm.api_token).trim();
    }

    var scripts = document.querySelectorAll("script");
    for (var i = 0; i < scripts.length; i++) {
      var text = scripts[i].textContent || "";
      var match = text.match(/api_token['"]\s*:\s*['"]([^'"]+)['"]/);
      if (match && match[1]) return match[1].trim();
    }

    return "";
  }

  function waitForJudgeMeToken(timeout) {
    return new Promise(function (resolve) {
      var started = Date.now();

      function check() {
        var token = discoverJudgeMeToken();
        if (token) {
          resolve(token);
          return;
        }
        if (Date.now() - started > timeout) {
          resolve("");
          return;
        }
        setTimeout(check, 200);
      }

      check();
    });
  }

  function getSectionConfig(section) {
    var token = (section.dataset.judgemeToken || "").trim();
    var shopDomain = (section.dataset.shopDomain || "").trim();

    var configEl = section.querySelector(".ko-judgeme-config");
    if (configEl) {
      try {
        var parsed = JSON.parse(configEl.textContent || "{}");
        if (!token) token = (parsed.token || "").trim();
        if (!shopDomain) shopDomain = (parsed.shopDomain || "").trim();
      } catch (e) {
        /* ignore */
      }
    }

    if (!token) token = discoverJudgeMeToken();

    if (!shopDomain && window.Shopify && window.Shopify.shop) {
      shopDomain = window.Shopify.shop;
    }

    if (window.jdgm && window.jdgm.SHOP_DOMAIN) {
      shopDomain = shopDomain || window.jdgm.SHOP_DOMAIN;
    }

    if (window.jdgmSettings && window.jdgmSettings.shop_domain) {
      shopDomain = shopDomain || window.jdgmSettings.shop_domain;
    }

    return {
      token: token,
      shopDomain: shopDomain,
      shopDomains: getShopDomainCandidates(section, shopDomain),
      count: parseInt(section.dataset.reviewCount, 10) || 7,
      reviewsUrl: section.dataset.reviewsUrl || "/pages/judgeme-reviews",
      source: section.dataset.reviewSource || "manual",
    };
  }

  function getShopDomainCandidates(section, primary) {
    var list = [];
    function add(d) {
      d = (d || "").trim();
      if (!d || list.indexOf(d) !== -1) return;
      list.push(d);
    }

    add(primary);
    if (section.dataset.shopDomainAlt) add(section.dataset.shopDomainAlt);
    if (window.Shopify && window.Shopify.shop) add(window.Shopify.shop);
    if (window.jdgm && window.jdgm.SHOP_DOMAIN) add(window.jdgm.SHOP_DOMAIN);
    if (window.jdgmSettings && window.jdgmSettings.shop_domain) add(window.jdgmSettings.shop_domain);

    return list.length ? list : [""];
  }

  function parseRatingFromRev(el) {
    var ratingEl = el.querySelector(".jdgm-rev__rating");
    if (!ratingEl) {
      var stars = el.querySelectorAll(".jdgm-star.jdgm--on");
      if (stars.length) return stars.length;
      return 5;
    }
    var score = parseInt(ratingEl.getAttribute("data-score"), 10);
    return isNaN(score) ? 5 : score;
  }

  function readReviewTitle(el) {
    var titleEl = el.querySelector(".jdgm-rev__title");
    if (titleEl) return stripHtml(titleEl.textContent || "");

    return "";
  }

  function readReviewBody(el) {
    var bodyEl = el.querySelector(".jdgm-rev__body");
    if (bodyEl) return stripHtml(bodyEl.innerHTML || bodyEl.textContent || "");

    var carouselReview = el.querySelector(".jdgm-carousel-item__review");
    if (carouselReview) return stripHtml(carouselReview.textContent || "");

    return "";
  }

  var NOISE_TITLES = [
    "memnuniyet",
    "memnuniyetim",
    "kolayoto",
    "kolay oto",
    "harika",
    "mükemmel",
    "mukemmel",
    "güzel",
    "guzel",
    "iyi",
    "teşekkürler",
    "tesekkurler",
    "thanks",
    "thank you",
    "great",
    "excellent",
    "good",
    "perfect",
    "satisfaction",
  ];

  function cleanReviewBody(body) {
    if (!body) return "";
    return body
      .trim()
      .replace(/^memnuniyet(?:im)?(?:\s+olarak)?[\s,.:;!\-–—]*/i, "")
      .trim();
  }

  function dedupeStartingPhrase(text) {
    if (!text) return "";
    var normalized = text.replace(/\s+/g, " ").trim();
    var half = Math.floor(normalized.length / 2);
    if (half < 18) return normalized;

    function normalizeForCompare(value) {
      return value
        .toLowerCase()
        .replace(/[^a-z0-9ğüşöçıİĞÜŞÖÇ\s]/gi, "")
        .replace(/\s+/g, " ")
        .trim();
    }

    // If first phrase is duplicated back-to-back, keep one copy.
    var firstPart = normalized.slice(0, half).trim();
    var secondPart = normalized.slice(half).trim();
    if (firstPart && secondPart) {
      var a = normalizeForCompare(firstPart);
      var b = normalizeForCompare(secondPart);
      if (a && b && (a === b || b.indexOf(a) === 0)) {
        return firstPart;
      }
    }

    var sentenceMatch = normalized.match(/^(.{8,140}?[.!?])\s+\1/i);
    if (sentenceMatch && sentenceMatch[1]) {
      return normalized.replace(sentenceMatch[0], sentenceMatch[1] + " ").trim();
    }

    return normalized;
  }

  function isNoiseTitle(title, productTitle) {
    if (!title) return true;

    var norm = title.toLowerCase().trim().replace(/\s+/g, " ");
    var compact = norm.replace(/\s+/g, "");

    if (norm.length < 2) return true;
    if (NOISE_TITLES.indexOf(norm) !== -1 || NOISE_TITLES.indexOf(compact) !== -1) return true;

    if (productTitle) {
      var productNorm = productTitle.toLowerCase().trim();
      var productCompact = productNorm.replace(/\s+/g, "");
      if (norm === productNorm || compact === productCompact) return true;
    }

    return false;
  }

  function normalizeReviewFields(review) {
    var productTitle = (review.productTitle || "").trim();
    var title = (review.title || "").trim();
    var body = cleanReviewBody((review.body || "").trim());

    if (isNoiseTitle(title, productTitle)) {
      title = "";
    }

    if (title && !body) {
      body = title;
      title = "";
    }

    if (title && body) {
      var titleNorm = title.toLowerCase();
      var bodyNorm = body.toLowerCase();

      if (bodyNorm === titleNorm) {
        title = "";
      } else if (bodyNorm.indexOf(titleNorm) === 0) {
        body = body.slice(title.length).replace(/^[\s,.:;!\-–—]+/, "").trim();
        if (!body) {
          body = cleanReviewBody((review.body || "").trim());
          title = "";
        }
      }
    }

    if (isNoiseTitle(title, productTitle)) {
      title = "";
    }

    body = dedupeStartingPhrase(cleanReviewBody(body));

    return Object.assign({}, review, {
      title: title,
      body: body,
      productTitle: undefined,
    });
  }

  function reviewKey(review) {
    if (review.id) return "id:" + review.id;
    return [
      review.name || "",
      review.title || "",
      review.body || "",
    ]
      .join("|")
      .toLowerCase();
  }

  function parseReviewFromRevElement(el) {
    var title = readReviewTitle(el);
    var body = readReviewBody(el);

    var timestamp =
      (el.querySelector(".jdgm-rev__timestamp") &&
        el.querySelector(".jdgm-rev__timestamp").getAttribute("data-content")) ||
      (el.querySelector("time") && el.querySelector("time").getAttribute("datetime")) ||
      "";

    var name =
      ((el.querySelector(".jdgm-rev__author") && el.querySelector(".jdgm-rev__author").textContent) ||
        (el.querySelector(".jdgm-rev__author-wrapper") &&
          el.querySelector(".jdgm-rev__author-wrapper").textContent) ||
        (el.querySelector(".jdgm-carousel-item__reviewer-name") &&
          el.querySelector(".jdgm-carousel-item__reviewer-name").textContent) ||
        "") + "";

    name = name.replace(/\s+(verified|buyer|müşteri)\b/gi, "").trim() || "Anonim";

    var id =
      el.getAttribute("data-review-id") ||
      (el.dataset && el.dataset.reviewId) ||
      "";

    var productTitle = "";
    var prodLink = el.querySelector(".jdgm-rev__prod-link, .jdgm-carousel-item__product-title");
    if (prodLink) productTitle = stripHtml(prodLink.textContent || "");

    return normalizeReviewFields({
      id: id,
      rating: parseRatingFromRev(el),
      title: title,
      body: body,
      name: name,
      created_at: timestamp,
      productTitle: productTitle,
    });
  }

  function parseReviewFromApi(review) {
    if (review.hidden) return null;

    return normalizeReviewFields({
      id: review.id,
      rating: Math.round(parseFloat(review.rating) || 5),
      title: stripHtml(review.title || ""),
      body: stripHtml(review.body || ""),
      name: (
        (review.reviewer && review.reviewer.name) ||
        review.reviewer_name ||
        review.author ||
        review.name ||
        "Anonim"
      ).trim(),
      created_at: review.created_at || "",
      productTitle: stripHtml(review.product_title || ""),
    });
  }

  function hasReviewContent(review) {
    return !!(review && (review.title || review.body));
  }

  function sortReviewsNewest(reviews) {
    function toDateMs(value) {
      if (!value) return NaN;
      var ms = new Date(value).getTime();
      if (!isNaN(ms)) return ms;

      // Fallback for numeric epoch-like values.
      var numeric = parseInt(String(value).replace(/[^\d]/g, ""), 10);
      if (!isNaN(numeric) && numeric > 0) return numeric;
      return NaN;
    }

    function toIdNum(value) {
      var id = parseInt(value, 10);
      return isNaN(id) ? NaN : id;
    }

    return reviews.slice().sort(function (a, b) {
      var dateA = toDateMs(a.created_at);
      var dateB = toDateMs(b.created_at);
      var hasDateA = !isNaN(dateA);
      var hasDateB = !isNaN(dateB);

      if (hasDateA && hasDateB && dateA !== dateB) return dateB - dateA;
      if (hasDateA && !hasDateB) return -1;
      if (!hasDateA && hasDateB) return 1;

      var idA = toIdNum(a.id);
      var idB = toIdNum(b.id);
      var hasIdA = !isNaN(idA);
      var hasIdB = !isNaN(idB);

      if (hasIdA && hasIdB && idA !== idB) return idB - idA;
      if (hasIdA && !hasIdB) return -1;
      if (!hasIdA && hasIdB) return 1;

      var idxA = typeof a.source_index === "number" ? a.source_index : Number.MAX_SAFE_INTEGER;
      var idxB = typeof b.source_index === "number" ? b.source_index : Number.MAX_SAFE_INTEGER;
      return idxA - idxB;
    });
  }

  function collectReviewsFromRoot(root, count) {
    if (!root) return [];

    var reviews = [];
    var seen = {};

    var sourceIndex = 0;

    function addReview(parsed) {
      if (!hasReviewContent(parsed)) return;
      if (typeof parsed.source_index !== "number") parsed.source_index = sourceIndex;
      sourceIndex += 1;
      var key = reviewKey(parsed);
      if (seen[key]) return;
      seen[key] = true;
      reviews.push(parsed);
    }

    var revNodes = root.querySelectorAll(".jdgm-rev");
    if (revNodes.length) {
      Array.prototype.forEach.call(revNodes, function (el) {
        addReview(parseReviewFromRevElement(el));
      });
    } else {
      Array.prototype.forEach.call(root.querySelectorAll(".jdgm-carousel-item"), function (el) {
        addReview(parseReviewFromRevElement(el));
      });
    }

    return sortReviewsNewest(reviews).slice(0, count);
  }

  function triggerJudgeMeRefresh() {
    if (typeof window.jdgm_preloader === "function") {
      window.jdgm_preloader();
      return;
    }
    if (window.jdgm) {
      if (typeof window.jdgm.loadWidgets === "function") window.jdgm.loadWidgets();
      if (typeof window.jdgm.customizeBadges === "function") window.jdgm.customizeBadges();
      if (typeof window.jdgm.customize === "function") window.jdgm.customize();
    }
  }

  function waitForDomReviews(section, count) {
    return new Promise(function (resolve, reject) {
      var source = section.querySelector("[data-ko-jdgm-source]");
      var roots = [];

      if (source) roots.push(source);
      roots.push(section);

      var featured = document.querySelector(
        '[id*="judgeme_featured"], .jdgm-carousel-wrapper, .jdgm-featured-carousel, .jdgm-all-reviews-page, .jdgm-shop-reviews'
      );
      if (featured) roots.push(featured.closest("section, div") || featured);

      var started = Date.now();
      var preloaderRuns = 0;

      function poll() {
        for (var i = 0; i < roots.length; i++) {
          var reviews = collectReviewsFromRoot(roots[i], count);
          if (reviews.length) {
            resolve(reviews);
            return;
          }
        }

        if (Date.now() - started > DOM_TIMEOUT_MS) {
          reject(new Error("dom_timeout"));
          return;
        }

        if (preloaderRuns < 4 && Date.now() - started > preloaderRuns * 2000) {
          preloaderRuns += 1;
          triggerJudgeMeRefresh();
        }

        setTimeout(poll, DOM_POLL_MS);
      }

      triggerJudgeMeRefresh();
      poll();
    });
  }

  function buildQuery(params) {
    var parts = [];
    Object.keys(params).forEach(function (key) {
      if (params[key] === undefined || params[key] === null || params[key] === "") return;
      parts.push(encodeURIComponent(key) + "=" + encodeURIComponent(String(params[key])));
    });
    return parts.join("&");
  }

  function requestJudgeMe(path, shopDomain, token, params) {
    if (!token) return Promise.reject(new Error("missing_token"));

    var query = buildQuery(Object.assign({ shop_domain: shopDomain }, params || {}));
    var url =
      API_HOST +
      path +
      "?" +
      query +
      (query ? "&" : "") +
      "api_token=" +
      encodeURIComponent(token);

    return fetch(url, {
      method: "GET",
      headers: { Accept: "application/json" },
      credentials: "omit",
    }).then(function (res) {
      if (!res.ok) {
        var err = new Error("http_" + res.status);
        err.status = res.status;
        throw err;
      }
      return res.json();
    });
  }

  function parseWidgetHtml(data) {
    return (data && (data.widget || data.html || data.content)) || "";
  }

  function fetchReviewsFromWidget(shopDomain, token, count) {
    return requestJudgeMe("widgets/all_reviews_page", shopDomain, token, {
      page: 1,
    })
      .then(function (pageData) {
        var pageHtml = parseWidgetHtml(pageData);
        if (!pageHtml) return [];
        var temp = document.createElement("div");
        temp.innerHTML = pageHtml;
        return collectReviewsFromRoot(temp, count);
      })
      .then(function (reviews) {
        if (reviews.length) return reviews;
        return requestJudgeMe("widgets/featured_carousel", shopDomain, token, {}).then(function (data) {
          var html = parseWidgetHtml(data);
          if (!html) return [];
          var temp2 = document.createElement("div");
          temp2.innerHTML = html;
          return collectReviewsFromRoot(temp2, count);
        });
      });
  }

  function fetchReviewsFromApi(shopDomain, token, count) {
    var fetchCount = Math.min(Math.max(count * 3, count), 50);

    return requestJudgeMe("reviews", shopDomain, token, {
      per_page: fetchCount,
      page: 1,
    }).then(function (data) {
      var list = ((data && data.reviews) || [])
        .map(parseReviewFromApi)
        .filter(function (r) {
          return r && hasReviewContent(r);
        });
      return sortReviewsNewest(list).slice(0, count);
    });
  }

  function fetchReviewsFromPublicPage(config) {
    if (!config.reviewsUrl) return Promise.resolve([]);

    return fetch(config.reviewsUrl, {
      method: "GET",
      credentials: "same-origin",
      headers: { Accept: "text/html" },
    })
      .then(function (res) {
        if (!res.ok) throw new Error("reviews_page_http_" + res.status);
        return res.text();
      })
      .then(function (html) {
        if (!html) return [];
        var temp = document.createElement("div");
        temp.innerHTML = html;
        return collectReviewsFromRoot(temp, config.count);
      })
      .catch(function () {
        return [];
      });
  }

  function fetchReviewsViaApi(config) {
    if (!config.token) return Promise.reject(new Error("missing_token"));

    var domains = config.shopDomains.filter(Boolean);
    if (!domains.length) return Promise.reject(new Error("missing_shop"));

    function tryDomain(index) {
      if (index >= domains.length) return Promise.reject(new Error("api_failed"));
      var domain = domains[index];

      return fetchReviewsFromApi(domain, config.token, config.count)
        .then(function (reviews) {
          if (reviews.length) return reviews;
          return fetchReviewsFromWidget(domain, config.token, config.count);
        })
        .catch(function () {
          return tryDomain(index + 1);
        });
    }

    return tryDomain(0);
  }

  function loadJudgeMeReviews(section, config) {
    // Judge.me API is blocked by CORS on storefront domains.
    // Read reviews only from Judge.me app block DOM rendered in theme.
    return waitForDomReviews(section, config.count);
  }

  function renderStars(rating) {
    var stars = "";
    var rounded = Math.max(0, Math.min(5, Math.round(rating)));
    for (var i = 0; i < 5; i++) {
      stars += '<span class="star' + (i < rounded ? "" : " star--empty") + '">★</span>';
    }
    return stars;
  }

  function renderReviewText(review) {
    var html = "";
    var title = review.title ? truncateText(review.title, 120) : "";
    var body = review.body ? truncateText(review.body, 260) : "";

    if (title) {
      html += '<p class="review-title">' + escapeHtml(title) + "</p>";
    }
    if (body) {
      html += '<p class="description">' + escapeHtml(body) + "</p>";
    }

    return html;
  }

  function renderSlide(review, config) {
    var contentHtml = renderReviewText(review);
    if (!contentHtml) return "";

    return (
      '<div class="swiper-slide testimonial-card">' +
      '<div class="stars">' +
      renderStars(review.rating) +
      "</div>" +
      contentHtml +
      '<p class="author">— <b>' +
      escapeHtml(review.name) +
      "</b></p>" +
      "</div>"
    );
  }

  function getSwiperOptions(sliderEl) {
    var paginationEl = sliderEl.querySelector(".swiper-pagination");
    return {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      pagination: {
        el: paginationEl || ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        640: { slidesPerView: 2, spaceBetween: 20 },
        1024: { slidesPerView: 3, spaceBetween: 30 },
      },
    };
  }

  function initSwiper(sliderEl) {
    if (typeof Swiper === "undefined" || !sliderEl) return null;
    if (sliderEl.swiper) sliderEl.swiper.destroy(true, true);
    return new Swiper(sliderEl, getSwiperOptions(sliderEl));
  }

  function showError(wrapper, message) {
    if (!wrapper) return;
    wrapper.innerHTML =
      '<div class="swiper-slide testimonial-card testimonials-empty"><p class="description">' +
      escapeHtml(message) +
      "</p></div>";
  }

  function renderJudgeMeSlides(section, reviews, config) {
    var wrapper = section.querySelector("[data-ko-testimonials-wrapper]");
    var sliderEl = section.querySelector(".testimonials-slider");
    if (!wrapper || !reviews.length) return false;

    var html = reviews
      .map(function (review) {
        return renderSlide(review, config);
      })
      .filter(Boolean)
      .join("");

    if (!html) return false;

    if (config.source === "judgeme_latest") {
      wrapper.innerHTML = html;
    } else {
      wrapper.insertAdjacentHTML("beforeend", html);
    }

    initSwiper(sliderEl);
    return true;
  }

  function initSection(section) {
    var config = getSectionConfig(section);
    var sliderEl = section.querySelector(".testimonials-slider");
    var wrapper = section.querySelector("[data-ko-testimonials-wrapper]");

    if (config.source === "manual") {
      initSwiper(sliderEl);
      return;
    }

    var hasJudgeBlock = !!section.querySelector(
      "[data-ko-jdgm-source] .jdgm-widget, [data-ko-jdgm-source] [class*='jdgm']"
    );

    waitForJudgeMeToken(TOKEN_WAIT_MS)
      .then(function (discoveredToken) {
        if (discoveredToken && !config.token) config.token = discoveredToken;
        return loadJudgeMeReviews(section, config);
      })
      .then(function (reviews) {
        if (renderJudgeMeSlides(section, reviews, config)) return;
        throw new Error("empty_reviews");
      })
      .catch(function (err) {
        if (config.source !== "judgeme_latest") {
          initSwiper(sliderEl);
          return;
        }

        var message =
          "En güncel yorumlar yüklenemedi. Testimonials bölümüne Judge.me 'All Reviews Page' app bloğu ekleyin ve app embed'in aktif olduğundan emin olun.";

        if (err && err.message === "missing_token" && !hasJudgeBlock) {
          message =
            "Judge.me yorumları alınamadı. Testimonials bölümüne Judge.me app bloğu ekleyin veya Judge.me API token girin.";
        }

        showError(wrapper, message);
        initSwiper(sliderEl);
      });
  }

  function boot() {
    document.querySelectorAll("[data-ko-testimonials]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector("[data-ko-testimonials]");
    if (section) initSection(section);
  });
})();
